// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Volume Button

systemSettingVolumeButton = {};

systemSettingVolumeButton.create = function() {
	var button = new PIXI.Container();

	InputHelpers.addGenerics(button);
	button._flags.muted = false;
	
	button.canEnable = function() {
		return soundManager.soundAvailable();
	};

	button.canShow = function() { 
		return settingsMenu.buttons.btnSound.visible;
	}

	button.showButton = function() {
		if (this.canShow()) {
			if (button._flags.muted) {
				this.button.buttonDisabled.visible = true;
				this.button.buttonEnabled.visible = false;
			} else {
				this.button.buttonDisabled.visible = false;
				this.button.buttonEnabled.visible = true;
			}

			resourceManager.get( "systemSettings:systemSettingsBox:soundsToggleText" ).visible = true;
			this.button.visible = true;
		} else {
			this.hideButton();
			resourceManager.get( "systemSettings:systemSettingsBox:soundsToggleText" ).visible = false;			
		}
	};

	button.onPressedCallback = function() {
		messageBus.post("audio:stateChanged", {
			type: "audio:stateChanged",
			muted: !this._flags.muted
		});
	};
	
	button.onCurrentMuteState = function(state) {
		this._flags.muted = state.muted;
	};
	
	messageBus.subscribe("audio:currentMuteState", button.onCurrentMuteState.bind(button));

	return button;
};

systemSettingVolumeButton.initialise = function(json, object) {};
systemSettingVolumeButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("systemSettingVolumeButton", systemSettingVolumeButton.create, systemSettingVolumeButton.initialise, systemSettingVolumeButton.getFilesRequired);